/**
 * ADHA unit title: "Unit Number, Project Name, Project Location".
 * Empty segments are dropped (same pattern as web listing cards).
 */
export function formatAdhaUnitTitle(
  unitNumber?: string | null,
  projectName?: string | null,
  projectLocation?: string | null,
): string {
  return [unitNumber, projectName, projectLocation]
    .map((part) => (typeof part === 'string' ? part.trim() : ''))
    .filter(Boolean)
    .join(', ');
}

/** Contentful `fields.name` when present; otherwise Salesforce / Boomi. */
export function resolveAdhaProjectName(
  salesforceName?: string | null,
  contentfulName?: string | null,
): string {
  const fromContentful = contentfulName?.trim();
  if (fromContentful) {
    return fromContentful;
  }
  return salesforceName?.trim() || '';
}

/** Contentful locale description when present; otherwise Salesforce. */
export function resolveAdhaProjectDescription(
  salesforceDescription?: string | null,
  contentfulDescription?: string | null,
): string | undefined {
  const fromContentful = contentfulDescription?.trim();
  if (fromContentful) {
    return fromContentful;
  }
  const fromSalesforce = salesforceDescription?.trim();
  return fromSalesforce || undefined;
}
